module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (228).9dd68a8e.jpg";